// extracted by mini-css-extract-plugin
export default {"box":"index_box__ZgUmq","item":"index_item__ttXwO","line":"index_line__4Dpnu","left":"index_left__TliAU","right":"index_right__fyPaa","btn_area":"index_btn_area__vlaFy"};